'use client';

import React from 'react';
import { RegFormField } from '@/features/b2b/register/components/RegFormField';
import { FormRadioGroup } from '@/components/ui/FormRadioGroup';

export const BankDetailsSection = ({ formData, handleInputChange, handleSelectChange, errors }) => {
  const authorisedOptions = ['Yes', 'No'];

  const handleAuthorisedChange = (selectedValue) => {
    const mappedValue = selectedValue === 'Yes' ? '1' : '0';
    const event = { target: { name: 'authorised', value: mappedValue } };
    handleInputChange(event);

    // Clear bank details when selecting "No"
    if (mappedValue === '0') {
      handleSelectChange('account')('');
      handleSelectChange('accountNumber')('');
      handleSelectChange('sortCode')('');
    }
  };

  const handleNumericInput = (e) => {
    e.target.value = e.target.value.replace(/[^\d,]/g, '');
    handleInputChange(e);
  };

  return (
    <>
      <div className="mb-6">
        <p className="text-[#373945] text-base font-medium mb-2">
          Are you directly authorised?
        </p>
        <p className="text-[#373945] text-sm font-medium mb-2">
          Directly Authorised firms need to provide their bank details to finalise registration.
          This does not apply to Appointed Representatives.
        </p>
        <FormRadioGroup
          name="authorised"
          label=""
          value={formData.authorised === '1' ? 'Yes' : formData.authorised === '0' ? 'No' : ''}
          onChange={handleAuthorisedChange}
          options={authorisedOptions}
          isVertical={false}
          error={errors.authorised}
        />
      </div>

      {formData.authorised === '1' && (
        <div>
          <RegFormField
            label="Bank account name"
            name="account"
            value={formData.account}
            onChange={handleInputChange}
            placeholder="John Smith's Account"
            error={errors.account}
          />

          <div className="flex gap-1">
            <div>
              <RegFormField
                label="Account number"
                name="accountNumber"
                value={formData.accountNumber}
                onChange={handleNumericInput}
                placeholder="72345678"
                error={errors.accountNumber}
                min="10000000"
                max="99999999"
              />
            </div>

            <div>
              <RegFormField
                label="Sort code"
                name="sortCode"
                value={formData.sortCode}
                onChange={handleNumericInput}
                placeholder="12-34-56"
                error={errors.sortCode}
                min="100000"
                max="999999"
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
};
